import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { ContractDeliveryForm } from '@/components/contract-delivery/contract-delivery-form'
import { useCreateContractDelivery } from '@/hooks/use-contract-delivery-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/contract-deliveries/new',
)({
    component: NewContractDeliveryPage,
})

function NewContractDeliveryPage() {
    const navigate = useNavigate()
    const createMutation = useCreateContractDelivery()

    const handleCancel = () =>
        void navigate({ to: '/contract-deliveries' })

    return (
        <div className="space-y-5 p-4 md:p-6">
            <div className="flex items-center gap-3">
                <button
                    type="button"
                    onClick={handleCancel}
                    aria-label={m.cdo_back()}
                    className="flex size-9 items-center justify-center rounded-lg border text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                >
                    <ArrowLeft className="size-4" />
                </button>
                <h1 className="text-xl font-semibold tracking-tight">
                    {m.cdo_new_title()}
                </h1>
            </div>
            <ContractDeliveryForm
                isPending={createMutation.isPending}
                onCancel={handleCancel}
                onSubmit={(data) =>
                    createMutation.mutate(data, {
                        onSuccess: (res) => {
                            const id = res.data?.id
                            if (id) {
                                void navigate({
                                    to: '/contract-deliveries/$id',
                                    params: { id },
                                })
                            } else {
                                void navigate({ to: '/contract-deliveries' })
                            }
                        },
                    })
                }
            />
        </div>
    )
}
